<script setup lang="ts">
// For PToaster styles
import 'vue-sonner/style.css';
import { env } from '@/config/env.js';
import { RouterView } from 'vue-router';
import { onErrorCaptured } from 'vue';
import { PSonner } from '@pokerly/ui';
import { useFeatureFlags } from '@/composables/use-feature-flags.ts';
import ErrorBoundary from '@/components/ErrorBoundary.vue';
import { useClarity } from '@/composables/use-clarity.ts';
import { useGoogleAnalytics } from '@/composables/use-google-analytics.ts';

// Dev tools (only in development)
import { PokerlyDevTools } from '@/dev-tools';

useFeatureFlags();
useClarity();
useGoogleAnalytics();

// Global error handler for unhandled promise rejections
onErrorCaptured((err: unknown) => {
    console.error('Unhandled error in component:', err);
    return false; // Let ErrorBoundary handle it
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    event.preventDefault(); // Prevent default browser behavior
});
</script>

<template>
    <ErrorBoundary>
        <PSonner :expand="true" />
        <main class="min-h-screen bg-surface-muted">
            <RouterView />
        </main>
        <!-- Dev Tools - only visible in development -->
        <PokerlyDevTools v-if="env.MODE === 'development'" />
    </ErrorBoundary>
</template>
